"use client";
import React, { useState } from "react";
import Link from "next/link";

function ProgramList({ programsData }) {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleAccordion = (i) => {
    setOpenIndex(openIndex === i ? null : i);
  };

  return (
    <>
      {/* PROGRAM LIST FROM JSON */}
      <div className="max-w-[var(--max-page-width)] px-[var(--container-padding)] mx-auto pt-12  pb-0 sm:pt-16 sm:pb-12">
        <div className=" mx-auto space-y-8">
          {programsData.map((school, index) => (
            <div key={index} className="space-y-4">
              {/* ---------- MOBILE ACCORDION TITLE ---------- */}
              <div
                className="md:hidden flex justify-between items-center cursor-pointer bg-[#152938] text-white p-4 rounded-lg"
                onClick={() => toggleAccordion(index)}
              >
                <Link href={school.url || "#"}>
                  <h3 className="font-bold footer-subtitel">{school.title}</h3>
                </Link>

                <span className="text-xl">
                  {openIndex === index ? "−" : "+"}
                </span>
              </div>

              {/* ---------- MOBILE ACCORDION CONTENT ---------- */}
              {openIndex === index && (
                <div className="md:hidden pl-4 space-y-2 bg-[#152938]">
                  {school.programs.map((program, i) => (
                    <div key={i}>
                      <Link
                        href={program.slug || "#"}
                        prefetch={false}
                        className="text-gray-300 hover:text-white transition block py-1"
                      >
                        {program.name}
                      </Link>
                    </div>
                  ))}
                </div>
              )}

              {/* ---------- DESKTOP VIEW ---------- */}
              <div className="hidden md:block">
                <Link href={school.url || "#"}>
                  <p className="text-white font-medium footer-subtitle mb-2">
                    {school.title}
                  </p>
                </Link>
                <div className="flex flex-wrap text-gray-300 footer-link">
                  {school.programs.map((program, i) => (
                    <span key={i} className="flex items-center">
                      <Link
                        href={program.slug || "#"}
                        className="hover:text-[#efefef] text-xs transition cursor-pointer"
                      >
                        {program.name}
                      </Link>

                      {/* Separator only in desktop */}
                      {i < school.programs.length - 1 && (
                        <span className="px-4">|</span>
                      )}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default ProgramList;
